<template>
  <div class="h-full">
    <ActivityContainer :activities="activities" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ActivityContainer from '@c/Activity/ActivityContainer.vue'

export default {
  name: 'ThePaymentModeActivityPage',
  components: {
    ActivityContainer
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activities: []
    }
  },
  mounted() {
    this.fetchActivities()
  },
  methods: {
    ...mapActions({
      processFetchPaymentModeActivitiesAction:
        'paymentMode/fetchPaymentModeActivityByPaymentModeID'
    }),
    fetchActivities() {
      this.processFetchPaymentModeActivitiesAction({
        payment_mode_id: this.id
      }).then((response) => {
        this.activities = response.activities
      })
    }
  }
}
</script>
